"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createFakeErrorPayload = createFakeErrorPayload;
exports.createRequest = createRequest;
var _ApiError = require("./ApiError.cjs");
var _constants = require("./constants.cjs");
var _lib = require("./lib.cjs");
var _types = require("./types.cjs");
function extractHeaders(headers) {
  const result = {};
  headers.forEach((value, key) => {
    result[key] = value;
  });
  return result;
}
function extractResponse(response) {
  return {
    status: response.status,
    statusText: response.statusText,
    headers: extractHeaders(response.headers)
  };
}
function createFakeErrorPayload({
  status,
  statusText
}) {
  return {
    status: 'error',
    code: status,
    message: `Something went wrong: ${[status, statusText].filter(Boolean).join(' ')}`,
    errors: {
      ':global': [{
        code: status,
        message: statusText
      }]
    }
  };
}
async function createRequest(fetchImpl, url, options) {
  const {
    headers,
    method,
    payload,
    query
  } = options;
  try {
    const urlWithQuery = (0, _lib.createUrlWithQuery)(url, query);
    const response = await fetchImpl(urlWithQuery.href, {
      method,
      headers: {
        Accept: 'application/json',
        'Content-Type': _constants.CONTENT_TYPE,
        ...headers
      },
      body: payload ? JSON.stringify(payload) : undefined
    });

    // Fetch correctly throws an error in browser environment,
    // but when running in test environment (Jest), it fails silently
    // and 'response' becomes undefined, hence this extra condition.
    if (!response) {
      throw new Error(_constants.INVALID_URL_ERROR_MESSAGE);
    }

    // Response code is not between 200 - 299
    if (!response.ok) {
      // Try to parse the response as JSON, if it contains any error messages
      // from backend. If not, fake the error message.
      let responsePayload;
      try {
        responsePayload = await response.json();
      } catch (error) {
        responsePayload = createFakeErrorPayload(response);
      }
      throw new _ApiError.ApiError({
        payload: responsePayload,
        ...extractResponse(response)
      });
    }
    const responsePayload = response.status === _types.HttpCodes.NO_CONTENT ? undefined : await response.json();
    return {
      payload: responsePayload,
      ...extractResponse(response)
    };
  } catch (error) {
    // Fetch throws an error, if there is a connection problem (eg. network is down).
    // We do not have access to response, so we need to fake the error payload.
    // Since we also throw when response is not ok, re-throw the response data if available.
    const {
      status,
      statusText = error.message || _constants.NETWORK_PROBLEM_ERROR_MESSAGE,
      payload: errorPayload
    } = error;
    throw new _ApiError.ApiError({
      payload: errorPayload || createFakeErrorPayload({
        status,
        statusText
      }),
      status,
      statusText,
      headers: error.headers || {}
    });
  }
}